import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { API, baseURL, endpoints } from "../../api";
import { useAuth } from "../../context/Auth";
import { shareLink } from "../../utils/utils";
import { Modal } from "../../components";

const EnterEventSuccess = () => {
  const { postId, eventId } = useParams() || {}
  const { loginRedirectUrl } = useAuth()

  const [posterImage, setPosterImage] = useState()
  const [posterFile, setPosterFile] = useState()
  const [entrySuccessImage, setEntrySuccessImage] = useState()

  const [showModal, setModal] = useState(true)
  const [loading, setLoading] = useState(true)


  useEffect(() => {
    setLoading(true)
    API.get({ route: `${endpoints.EVENT}/detail?eventId=${eventId}` })
      .then((data) => {
        if (data?.result?.[0]?.posterImage) {
          setPosterImage(data?.result?.[0]?.posterImage)
        }

        if (data?.result?.[0]?.posterFile) {
          setPosterFile(data?.result?.[0]?.posterFile)
        }

        if (data?.result?.[0]?.entrySuccessImage) {
          setEntrySuccessImage(data?.result?.[0]?.entrySuccessImage)
        }
      }).finally(() => setLoading(false))
  }, [])

  console.log({ posterImage, posterFile, entrySuccessImage })

  return (
    <>
      <div className="card shadow-xss w-100 d-block d-flex border-0 p-4 mb-3 ">
        <div className="card-body d-flex align-items-center p-0">
          <h2 className="fw-700 mb-0 mt-0 font-md text-grey-900 align-item-center d-flex">
            <i className="fa-sharp fa-solid fa-circle-check font-xxl mr-11 text-share" />
            Event Entry Success
          </h2>
        </div>
      </div>

      <div className="card shadow-xss w-100 d-block d-flex border-0 p-4 mb-3 membership-payment-success">
        <div className="card-body align-items-center p-0">
          {entrySuccessImage && entrySuccessImage != 'null' ? (
            <div className="text-center mt-3">
              <img
                style={{ maxWidth: 'calc(85vh)' }}
                src={`${entrySuccessImage}`}
              />
            </div>
          ) : null}
          <div className="row mt-3 mb-3 justify-content-center">
            <div className="col-lg-8 d-flex justify-content-center">
              <a
                onClick={(e) => { e.preventDefault(); shareLink({ id: postId, image: entrySuccessImage }); }}
                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(`${baseURL}/api/v1/feed/share/${postId}/1`)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-share-fb">
                <div className="share-logos">
                  <div className="logo-wrapper">
                    <i className="fa-brands fa-instagram"></i>
                  </div>
                  <div className="logo-wrapper">
                    <i className="fa-brands fa-facebook-f"></i>
                  </div>
                </div>
                <span className="hidden-sm">Click and Share to Facebook &gt; Instagram</span>
                <span className="show-sm">Click and Share to Facebook &gt; Instagram</span>
              </a>
            </div>
          </div>

          <p>

            You have complete control over your Entry:

            <ul style={{ margin: 20, lineHeight: 1.6 }}>
              <li style={{ listStyle: 'disc', listStylePosition: 'inside' }}>To see when, where, and how to pay, go to <Link to="/pay-events"><strong>PAY</strong></Link> in MY EVENT.</li>
              <li style={{ listStyle: 'disc', listStylePosition: 'inside' }}>You can edit or withdraw your entry in <Link to="/pay-events"><strong>EDIT EVENT</strong></Link> before close of entries.</li>
              <li style={{ listStyle: 'disc', listStylePosition: 'inside' }}>Any personal changes you make in <Link to="/edit-profile"><strong>MY PROFILE</strong></Link> are automatically updated in the event (ensure your details are kept current).</li>
              <li style={{ listStyle: 'disc', listStylePosition: 'inside' }}>If available, download the event poster and Information PDF to your device.</li>
            </ul>
            The Promoter will email contest updates. For questions about your contest, contact the <Link to="/calendar"><strong>Promoter</strong></Link>. For ICN support, use <Link to="/contact"><strong>HELP</strong></Link> in CONTACT US.
          </p>


          <div className="d-flex justify-center align-center mt-5 mb-3">
            {posterImage ? <a download={posterImage} target="_blank" href={posterImage} type="submit" className="w200 text-white bg-current border-0 py-1 font-xss rounded-3 d-block text-center">
              <i className="fa-solid fa-download"></i> {" "}
              Event Poster</a> : null}
            {posterFile ? <a download={posterFile} target="_blank" href={posterFile} type="submit" className="w200 text-white bg-current border-0 py-1 font-xss rounded-3 ms-5 d-block text-center">
              <i className="fa-solid fa-download"></i> {" "}
              Event Information</a> : null}
          </div>
        </div>
      </div>
      <Modal
        show={showModal}
        onClick={() => {
          setModal(false);
        }}
        close={() => {
          setModal(false);
        }}
      >
        <div>
          <div className="row mt-3 mb-3 justify-content-center" style={{ maxWidth: 600, margin: '0 auto' }}>
            <div className="col-lg-12 d-flex justify-content-center">
              <a
                onClick={(e) => {
                  e.preventDefault();
                  setModal(false);
                  shareLink({ id: postId, image: entrySuccessImage });
                }}
                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(`${baseURL}/api/v1/feed/share/${postId}/1`)}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div style={{ position: 'relative' }} >
                  <img src={entrySuccessImage || "./images/share-popup.png"} style={{ opacity: loading ? 0 : 1 }} className="mb-3" />
                  {loading ? <div style={{ position: 'absolute', bottom: 0, left: 0, height: '100%', width: '100%', flexDirection: 'column', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <img src="./images/preloader.svg" />
                  </div> : null}
                </div>
                <span
                  className="btn-share-fb">
                  <div className="share-logos">
                    <div className="logo-wrapper">
                      <i className="fa-brands fa-instagram"></i>
                    </div>
                    <div className="logo-wrapper">
                      <i className="fa-brands fa-facebook-f"></i>
                    </div>
                  </div>
                  <span className="hidden-sm bold" style={{ textShadow: '0 1px 3px rgba(0,0,0,0.5)' }}>Click and Share to Facebook &gt; Instagram</span>
                  <span className="show-sm">Click and Share to Facebook &gt; Instagram</span>
                </span>
              </a>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default EnterEventSuccess;
